<template>
    <b-modal v-if="!loading" id="signature_form" ref="signature_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Signature' : 'Edit Signature' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <div v-if="validationError">
            <b-row>
                <b-colxx lg="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>
        </div>

        <b-form>

            <b-row>
                <b-colxx v-if="edit" lg="12">
                    <b-alert show variant="info">
                        Facility: {{ selected.facility.label }} <br>
                        Date: {{ form.date }}
                    </b-alert>
                </b-colxx>

                <template v-if="!edit">
                    <b-colxx md="8">
                        <b-form-group label="Facility" class="has-float-label">
                            <template v-slot:label>
                                <span>Facility <sup><code>*</code></sup></span>
                            </template>

                            <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                      :border-danger="'facility_id' in errors"/>

                            <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                     v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                        </b-form-group>
                    </b-colxx>

                    <b-colxx md="4">
                        <b-form-group label="Date" class="has-float-label">
                            <template v-slot:label>
                                <span>Date <sup><code>*</code></sup></span>
                            </template>

                            <v-date-picker
                                popover-visibility="focus" mode="single" popover-align="right"
                                v-model="datepicker.date"
                                @input="checkDuplicate"
                                :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                            <b-form-invalid-feedback :state="!('date' in errors)"
                                                     v-text="'date' in errors ? errors.date[0] : ''"/>
                        </b-form-group>
                    </b-colxx>
                </template>
            </b-row>

            <div v-if="unitsLoaded && !hasError">
                <b-row>
                    <b-colxx md="12">
                        <b-form-checkbox v-model="toggle_all" @input="toggleAll">
                            Toggle All
                        </b-form-checkbox>
                    </b-colxx>
                </b-row>
                <b-row v-for="(unit, index) in form.contents" :key="index">
                    <b-colxx md="12">
                        <b-input-group class="mt-3 w-100">
                            <b-input-group-prepend class="w-25">
                                <b-input-group-text class="w-100">{{ unit.name }}</b-input-group-text>
                            </b-input-group-prepend>

                            <b-input-group-prepend is-text>
                                <input type="checkbox" v-model="unit.signed">
                            </b-input-group-prepend>

                            <b-form-input placeholder="Remarks" v-model="unit.remarks"/>
                        </b-input-group>
                    </b-colxx>
                </b-row>

                <b-row class="my-4">
                    <b-colxx md="12">
                        <vue-dropzone ref="fileDropZone" id="dropzone"
                                      @vdropzone-error="attachmentError"
                                      :destroy-dropzone="false" :options="dropzoneOptions"/>
                    </b-colxx>
                </b-row>
            </div>

            <b-row v-if="edit">
                <b-colxx md="12">
                    <FilesList v-if="form.attachments" :edit="true" :files="form.attachments.data"
                               @delete="deleteFile"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('signature_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitSignature">Submit</state-button>

            <state-button v-else variant="primary" :click="updateSignature">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import VueDropzone from 'vue2-dropzone';
import StateButton from "../../../../../components/Common/StateButton";
import moment from "moment";
import FilesList from "../../../../../components/Listing/FilesList";

export default {
    name: "SignatureFormModal",

    components: {
        StateButton,
        VueDropzone,
        FilesList,
    },

    props: [
        'edit',
    ],

    data() {
        return {
            loading: true,
            datepicker: {
                date: null,
            },
            selected: {
                facility: [],
            },
            deleted_attachments: [],
            unitsLoaded: false,
            hasError: false,
            validationError: null,
            toggle_all: false,
            extra_units: [],
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 30,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload SIGNATURE SHEETS.<br>Max file size 30MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getSignatureForm',
            facilities: 'getSelectFacilities',
            errors: 'getBillingErrors',
        })
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.facility = this.form.select_facility;

                this.datepicker.date = moment(this.form.date).toDate();

                if (this.form.contents.length > 0) {
                    this.unitsLoaded = true;
                }
            }
        },

        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        async getFormData() {
            await this.$store.dispatch('fetchSelectFacilities');

            return this.loading = false;
        },

        deleteFile(file) {
            this.deleted_attachments.unshift(file);
            this.form.attachments.data.splice(file.index, 1);
        },

        submitSignature() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitSignature', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new signatures!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('signature_form');
                        }, 2000);
                    })
                    .catch(error => {
                        this.validationError = error.response.data.error;

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateSignature() {
            let payload = {
                ...this.form,
                deleted_attachments: this.deleted_attachments,
            };

            return new Promise((success, fail) => {
                this.$store.dispatch('updateSignature', payload)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the signatures!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('signature_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        uploadFiles(signature) {
            let url = '/api/hms/signatures/' + signature.signature_id + '/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(signature);
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        updateFacility(field) {
            if (field) {
                this.form.facility_id = field.facility_id;
                this.form.contents = [];
                this.form.date = null;
                this.datepicker.date = null;
                this.validationError = null;
            } else {
                this.form.facility_id = '';
            }
            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        resetForm() {
            this.$store.commit('setSignatureForm');

            this.validationError = null;

            this.selected.facility = [];
            this.datepicker.date = null;

            this.unitsLoaded = false;

            this.toggle_all = false;
        },

        checkDuplicate(value) {
            let date = moment(value).format('YYYY-MM-DD');
            this.form.contents = [];
            let payload = {
                facility_id: this.form.facility_id,
                date: date,
            };
            axios.post('/api/hms/signatures/check', payload)
                .then(response => {
                    this.checkedSignature = response.data;
                    if (this.checkedSignature.success) {
                        this.hasError = false;
                        this.validationError = null;
                        this.fetchUnits(this.form.facility_id);
                    }
                })
                .catch(error => {
                    if (error.response.data.error) {
                        this.validationError = error.response.data.error;
                        this.hasError = true;
                        this.form.contents = [];
                        this.toggle_all = false;
                    } else if (error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }
                });

            'date' in this.errors ? (delete this.errors.date) : '';
        },

        fetchUnits(facility_id) {
            axios.get(`/api/hms/select/facility/${facility_id}/occupied-units?date=${this.form.date}`)
                .then(response => {
                    let scope = this;
                    let units = response.data.data;

                    if (units.length > 0) {
                        units.forEach(function (unit) {
                            scope.form.contents.push({
                                unit_id: unit.unit_id,
                                name: unit.data.attributes.name,
                                signed: false,
                                remarks: '',
                            });
                        });
                    }
                })
                .finally(() => {
                    this.unitsLoaded = true;
                });
        },

        toggleAll() {
            if (this.form.contents.length > 0) {
                if (this.toggle_all === true) {
                    this.form.contents.forEach(function (unit) {
                        unit.signed = true;
                    })
                } else if (this.toggle_all === false) {
                    this.form.contents.forEach(function (unit) {
                        unit.signed = false;
                    })
                }
            }
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },
    },
}
</script>

<style scoped>

</style>
